export default "__VITE_ASSET__91cf4c32__"